import { useEffect, useState } from 'react';

export const getParams = (location) => {
  return Object.fromEntries(new URLSearchParams(location?.search).entries());
};

export const setParams = (params) => {
  const update = new URLSearchParams(params).toString();
  try {
    window.history.replaceState(null, '', `?${update}`);
  } catch (error) {
    console.warn('Failed to replace state:', error);
  }

  return params;
};

export const updateParams = (location, params) => {
  const current = getParams(location);
  const updates = { ...current, ...params };
  setParams(updates);
  return updates;
};

export const useSearchParams = () => {
  const location = window.location;
  const [params, setParamsObj] = useState(getParams(location));

  const setParamsIntermediate = (params) => {
    const newParams = setParams(params);
    setParamsObj(newParams);
  };

  const updateParamsIntermediate = (params) => {
    const newParams = updateParams(location, params);
    setParamsObj(newParams);
  };

  const removeParam = (...param) => {
    let next = { ...params };
    for (const item of param) {
      delete next[item];
    }
    setParams(next);
    setParamsObj(next);
  };

  useEffect(() => {
    const onPop = () => setParamsObj(getParams(window.location));
    window.addEventListener('popstate', onPop);

    // monkey-patch replaceState to also fire popstate:
    const orig = window.history.replaceState;
    window.history.replaceState = function () {
      orig.apply(this, arguments);
      window.dispatchEvent(new PopStateEvent('popstate'));
    };

    return () => {
      window.removeEventListener('popstate', onPop);
      window.history.replaceState = orig;
    };
  }, []);

  return {
    params,
    removeParam,
    setParams: setParamsIntermediate,
    updateParams: updateParamsIntermediate,
  };
};
